module.exports = __webpack_public_path__ + "img/banner1.653615c.jpg";